import { useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PainelTv } from "@/components/tv/PainelTv";
import { PERIODOS, isPeriodo, type Periodo } from "./api";
import { useSlidesSilpiFarmaTv } from "./slidesTv";

/** Modo TV do dashboard Silpi Farma; Esc volta ao dashboard no mesmo período. */
export default function DashboardTv() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const periodoUrl = searchParams.get("periodo");
  const periodo: Periodo = isPeriodo(periodoUrl) ? periodoUrl : "tudo";

  const { slides, consultas } = useSlidesSilpiFarmaTv(periodo);

  const aoSair = useCallback(
    () => navigate(`/SilpiFarma/Dashboard${periodo === "tudo" ? "" : `?periodo=${periodo}`}`),
    [navigate, periodo],
  );

  return (
    <PainelTv
      slides={slides}
      consultas={consultas}
      subtitulo={PERIODOS.find((p) => p.value === periodo)?.label}
      aoSair={aoSair}
    />
  );
}
